import Vue from "vue";

const eventBus = new Vue();
export default eventBus;

export const EVENTS = {
  TOKENS_LOADED: "TOKENS_LOADED",
  FLOW_VALIDATION: "FLOW_VALIDATION",
  STATUS_UPDATED: "STATUS_UPDATED",
};
